import RidersComponent from "../components/Riders/RidersComponent";

const Riders = () => {
  return <RidersComponent />;
};

export default Riders;
